// Bootstrap the firebase sdk
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import "firebase/remote-config";

const firebaseProductionConfig = {
  apiKey: "AIzaSyD5n1sk97CCHzdN3nLhzrrANGTnxEXfChY",
  authDomain: "samply-a03ff.firebaseapp.com",
  databaseURL: "https://samply-a03ff.firebaseio.com",
  projectId: "samply-a03ff",
  storageBucket: "samply-a03ff.appspot.com",
  messagingSenderId: "489564606259",
  appId: "1:489564606259:web:afe33649ec5066fca43846",
  measurementId: "G-T3YJ93S39N"
};

const firebaseStagingConfig = {
  apiKey: "AIzaSyDlX10Uwww3zaw2_8fKHnh1GavRIt_INr8",
  authDomain: "samply-dev.firebaseapp.com",
  databaseURL: "https://samply-dev.firebaseio.com",
  projectId: "samply-dev",
  storageBucket: "samply-dev.appspot.com",
  messagingSenderId: "163042889593",
  appId: "1:163042889593:web:6f3550693bf75cf947e9a8",
  measurementId: "G-H5VKZB51W5"
};

// Initialize Firebase
firebase.initializeApp(
  process.env.VUE_APP_ENDPOINTS === "production"
    ? firebaseProductionConfig
    : firebaseStagingConfig
);
